import { useEffect } from "react";
import "@/App.css";
import { initLenis } from "./lib/scroll";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { InsideBook } from "./components/InsideBook";
import { AboutBook } from "./components/AboutBook";
import { FreeSample } from "./components/FreeSample";
import { Author } from "./components/Author";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="App bg-white text-[#1E2A2B] antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <InsideBook />
        <AboutBook />
        <FreeSample />
        <Author />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
